<template>
  <modal title="Reprice" height="270px" ref="modal" no-scroll>
    <template #top>
      <mode-selector v-model="mode" :modes="['Reprice', 'Automation']"/>
    </template>
    <template v-if="!!auction">
      <b-alert show v-if="auction.readonly" variant="danger">Can not modify manual or completed listing.</b-alert>
      <auction-automation v-else-if="mode == 'Automation'" v-model="rules" :price="auction.price"
                          :completed="auction.rules_executed"/>
      <div v-else-if="mode == 'Reprice'">
        <div class="pt-1 pb-2 mb-3 border-bottom">{{ auction.eb_Title }} (<a
            :href="'javascript:popupRightHalf(\'' + auction.eb_ViewItemURL + '\')'" v-text="auction.itemno"/>)
        </div>
        <b-row no-gutters>
          <b-col sm="6">
            <modal-row is-text even label="Qty / Sold">
              {{ auction.eb_Quantity }} / {{ auction.eb_QuantitySold }}
            </modal-row>
          </b-col>
          <b-col sm="6">
            <modal-row is-text even label="Fee">
              {{ auction.listing_fee | money }}
            </modal-row>
          </b-col>

          <b-col sm="6">
            <modal-row is-text even label="Price">
              {{ auction.price | money }}
            </modal-row>
          </b-col>
          <b-col sm="6">
            <modal-row is-text even label="Last Sale">
              <template v-if="auction.orders && !!auction.orders.length">{{
                  auction.orders[0].created | timediff
                }}
              </template>
              <template v-else>None</template>
            </modal-row>
          </b-col>
        </b-row>

        <modal-row :l-cols="3" is-text v-if="!!auction.price_log.length" label="Last Change">
          From {{ auction.price_log[0].last_price | money }} by {{ auction.price_log[0].createdby_user.userid }},
          {{ auction.price_log[0].created | timediff }}
        </modal-row>

        <modal-row :l-cols="3" v-if="item" is-text label="Links">
          <div v-for="i in item.research_urls" :key="i.value" class="mb-1">
            <a :href="'javascript:popupRightHalf(\'' + i.value + '\')'" v-text="i.text"/>
          </div>
        </modal-row>

        <div class="mt-3">
          <b-input-group prepend="$" size="sm">
            <b-form-input v-model="price" autofocus size="sm" type="number"/>
          </b-input-group>
          <b-button-group size="sm" class="mt-2 mb-3 float-right">
            <b-btn size="sm" @click="drop(0.95)">-5%</b-btn>
            <b-btn size="sm" @click="drop(0.9)">-10%</b-btn>
            <b-btn size="sm" @click="drop(0.8)">-20%</b-btn>
            <b-btn size="sm" @click="drop(0.75)">-25%</b-btn>
            <b-btn size="sm" @click="drop(0.7)">-30%</b-btn>
          </b-button-group>
        </div>
      </div>
    </template>
    <template #footer>
      <template v-if="!!auction && !auction.readonly">
        <b-btn variant="outline-secondary" class="px-3 mr-1" @click="nochange" size="sm">No Change</b-btn>
        <b-btn variant="outline-primary" class="px-3 mr-1" @click="edit" size="sm">Edit</b-btn>
        <b-btn variant="outline-primary" class="px-3 mr-1" @click="update" size="sm">Update</b-btn>
      </template>
    </template>
  </modal>
</template>

<script>

export default {
  name: "auction-repricer",

  components: {
    AuctionAutomation: () => import('./auction-automation.vue')
  },

  props: {
    url: String,
  },

  data() {
    return {
      mode: 'Reprice',
      auction: null,
      price: null,
      item: null,
      rules: null
    }
  },

  async mounted() {
    await this.load()
    this.price = this.auction.eb_StartPrice
    this.rules = this.auction.rules || []
  },

  methods: {
    edit() {
      popupRightHalf('/auction/' + this.auction.id + '/edit')
    },

    drop(amt) {
      this.price = this.auction.eb_StartPrice * amt
      this.price = this.price.toFixed(2)
    },

    clipboard(txt) {
      navigator.clipboard.writeText(txt).then(() => this.toast('Copied to clipboard.'))
    },

    async load() {
      this.auction = await this.asyncAction(this.url + '?with[]=orders', 'GET')
      if (this.auction._links.item_url)
        this.item = await this.asyncAction(this.auction._links.item_url.href + '?with[]=auction_gen', 'GET')
    },

    update() {
      this.$root.$emit('submit', {eb_StartPrice: this.price, rules: this.rules})
    },
    nochange() {
      this.$root.$emit('submit', {task: 'PriceLogNoChange'})
    }
  },
}
</script>

<style scoped>

</style>